<template>
  <div class="cube-loading">
    <span class="cube-loading-spinners" :style="style">
      <i class="cube-loading-spinner" :key="`spinner-item-${item}`" v-for="item in balde"></i>
    </span>
  </div>
</template>
<script>
import { computed , ref } from '@vue/runtime-core'
export default {
  name:'cube-loading',
  props:{
    size: {
      type: Number
    }
  },
  setup(props){
    let balde = ref(12)
    const style = computed(()=>{
      if (!props.size) {
        return
      }
      const value = `${props.size}px`
      return {
        width: value,
        height: value
      }
    })
    return {
      balde,
      style
    }
  }
}
</script>
<style lang="stylus">
.cube-loading
  font-size: 12px
.cube-loading-spinners
  position: relative
  display: block
  width: 1em
  height: 1em
.cube-loading-spinner
  position: absolute
  left: 44.5%
  top: 37%
  width: 2PX // for rem
  height: 25%
  border-radius: 50%/20%
  opacity: .25
  // background-color: currentColor
  background-color $text-title-color
  background-color var(--text-title-color)
  animation: spinner-fade 1s linear infinite
  for num in (1..12)
    &:nth-child({num})
      animation-delay: ((num - 1) / 12)s
      transform: rotate(30deg * (num - 6)) translateY(-150%)
@keyframes spinner-fade
  0%
    opacity: .85
  50%
    opacity: .25
  100%
    opacity: .25

</style>